import validate from 'validate.js';


export default {
  description: {
    presence: { allowEmpty: false, message: 'Descrierea este necesara!' },
  },
};
